const STORAGE_PREFIX = "ff-preview:";

const getPreviewKey = (preview) => {
  const name = preview
    .querySelector("[data-filename]")
    ?.textContent?.trim();
  const size = preview
    .querySelector("[data-filesize]")
    ?.textContent?.trim();

  if (!name) return null;
  return `${name}::${size || ""}`;
};

const cacheDataUrl = (preview) => {
  const thumb = preview.querySelector("[data-thumbnail]");
  if (!thumb) return;

  const bg = thumb.style.backgroundImage || "";
  const isDataUrl =
    bg.startsWith('url("data:') || bg.startsWith("url(data:");

  if (!isDataUrl) return;

  const key = getPreviewKey(preview);
  if (!key) return;

  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${key}`,
      bg.replace(/^url\((.*)\)$/, "$1")
    );
  } catch (_) {
    /* ignore storage errors */
  }
};

const applyCachedPreview = (preview) => {
  const thumb = preview.querySelector("[data-thumbnail]");
  if (!thumb) return;

  const bg = thumb.style.backgroundImage || "";
  const isDataUrl =
    bg.startsWith('url("data:') || bg.startsWith("url(data:");

  // If we already have a data URL, keep it.
  if (isDataUrl) return;

  const key = getPreviewKey(preview);
  if (!key) return;

  try {
    const cached = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (!cached) return;

    thumb.style.backgroundImage = cached.startsWith("url(")
      ? cached
      : `url(${cached})`;
    thumb.style.backgroundSize = "contain";
    thumb.style.backgroundRepeat = "no-repeat";
    thumb.style.backgroundColor = "transparent";
  } catch (_) {
    /* ignore storage errors */
  }
};

const handlePreview = (preview) => {
  cacheDataUrl(preview);
  applyCachedPreview(preview);
};

const initFreeformPreviewFix = () => {
  const zones = document.querySelectorAll(
    ".freeform-file-dnd__preview-zone"
  );

  zones.forEach((zone) => {
    zone
      .querySelectorAll("[data-file-preview]")
      .forEach(handlePreview);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches?.("[data-file-preview]")
          ) {
            handlePreview(node);
          } else if (node.querySelectorAll) {
            node
              .querySelectorAll("[data-file-preview]")
              .forEach(handlePreview);
          }
        });
      });
    });

    observer.observe(zone, { childList: true, subtree: true });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFreeformPreviewFix);
} else {
  initFreeformPreviewFix();
}
